import React,{useEffect} from 'react';
import Categories from '../categories/Categories';
import Products from '../product/Products';
import Hero from '../Hero/Hero';
import { useLocalContext } from '../../context/LocalContext';


const Home = () => {

  const { webinfo } = useLocalContext();
   useEffect(()=>{
      document.title = `Home | ${webinfo.name} `;
    })

  return (
    <>
      <div className=' home' style={{ width: '100%' }}>
        <Hero /> 
      </div>
      <Products />
      <Categories />
      
      {/* <AllCate /> */}
  
     
      
      {/* <Review /> */}
      {/* <About /> */}
      {/* <AboutShort /> */}
    </>
  );
};

export default Home;
